import {
	infographicSilent,
	infographicComfort,
	infographicClean,
} from '../../../assets/images/images';

export const HOUSE_HOLD_CONFIG = {
	infographic: [
		{
			title: 'HOUSE_HOLD.INFOGRAPHIC_SIlENT_TITLE',
			img: infographicSilent,
			description: 'HOUSE_HOLD.INFOGRAPHIC_SIlENT_BODY',
		},
		{
			title: 'HOUSE_HOLD.INFOGRAPHIC_COMFORT_TITLE',
			img: infographicComfort,
			description: 'HOUSE_HOLD.INFOGRAPHIC_COMFORT_BODY',
		},
		{
			title: 'HOUSE_HOLD.INFOGRAPHIC_CLEAN_TITLE',
			img: infographicClean,
			description: 'HOUSE_HOLD.INFOGRAPHIC_CLEAN_BODY',
		},
	],
	info: {
		telephone: '+32 475/ 44 39 49',
		email: ' info@aertech.be',
	},
};



// WEBPACK FOOTER //
// ./src/components/organisme/house_hold/house-hold.config.js